import React, { useContext, useEffect, useState } from "react";
import { Data } from "../App";

const InputText = ({
  name,
  type = null,
  sanitize = false,
  required = false,
  length = null,
  dtRef = null,
  ddRef = null,
  placeholder = null,
}) => {
  const { formData, setFormData, errors, setErrors } = useContext(Data);
  const [color, setColor] = useState();

  // 背景色を変える関数（必要？）
  const setColorScheme = (color) => {
    if (dtRef !== null && ddRef !== null) {
      switch (color) {
        case "red":
          dtRef.current.style.backgroundColor = "rgba(130, 67, 81, .3)";
          ddRef.current.style.backgroundColor = "rgba(130,67,81,.1)";
          break;
        case "blue":
          if (
            (name === "name" || name === "lastname") &&
            errors.name === null &&
            formData.name !== "" &&
            errors.lastname === null &&
            formData.lastname !== ""
          ) {
            dtRef.current.style.backgroundColor = "#dcdddd";
            ddRef.current.style.backgroundColor = "#ededed";
          } else if (
            (name === "furigana1" || name === "furigana2") &&
            errors.furigana1 === null &&
            formData.furigana1 !== null &&
            errors.furigana2 === null &&
            formData.furigana2 !== null
          ) {
            dtRef.current.style.backgroundColor = "#dcdddd";
            ddRef.current.style.backgroundColor = "#ededed";
          } else if (
            name !== "name" &&
            name !== "lastname" &&
            name !== "furigana1" &&
            name !== "furigana2"
          ) {
            dtRef.current.style.backgroundColor = "#dcdddd";
            ddRef.current.style.backgroundColor = "#ededed";
          }
          break;
        default:
      }
    }
  };
  // エラー更新時に色変更（必要？）
  useEffect(() => {
    setColorScheme(color);
  }, [color]);

  // バリデーション
  const checkInput = (input) => {
    if (required && input.length === 0) {
      setErrors({ ...errors, [name]: "*必須項目です" });
      setColor("red");
      return;
    }

    if (sanitize && /["',;`]/.test(input)) {
      setErrors({ ...errors, [name]: "*不正な文字が使用されています" });
      setColor("red");
      return;
    }

    if (length !== null && input.length !== length) {
      setErrors({
        ...errors,
        [name]: `*${length}文字で入力してください`,
      });
      setColor("red");
      return;
    }

    if (type !== null) {
      switch (type) {
        case "number":
          if (/^\d+$/.test(input)) {
            setErrors({ ...errors, [name]: null });
            setColor("blue");
          } else {
            setErrors({ ...errors, [name]: "*半角数字で入力してください" });
            setColor("red");
          }
          break;
        case "hiragana":
          if (/^[\u3040-\u309Fー]+$/.test(input)) {
            setErrors({ ...errors, [name]: null });
            setColor("blue");
          } else {
            setErrors({ ...errors, [name]: "*ひらがなで入力してください" });
            setColor("red");
          }
          break;
        case "katakana":
          if (/^[\u30A0-\u30FF]+$/.test(input)) {
            setErrors({ ...errors, [name]: null });
            setColor("blue");
          } else {
            setErrors({ ...errors, [name]: "*カタカナで入力してください" });
            setColor("red");
          }
          break;
        case "email":
          const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (regex.test(input)) {
            if (input === formData.emailcheck) {
              setErrors({ ...errors, [name]: null, emailcheck: null });
              setColor("blue");
            } else {
              setErrors({
                ...errors,
                [name]: null,
                emailcheck: "*メールアドレスが一致しません",
              });
              setColor("red");
            }
          } else {
            setErrors({
              ...errors,
              [name]: "*メールアドレスの形式が正しくありません",
              emailcheck: "*メールアドレスが一致しません",
            });
            setColor("red");
          }
          break;
        case "emailcheck":
          if (input === formData.email) {
            setErrors({ ...errors, [name]: null });
            if (errors.email === null) {
              setColor("blue");
            } else {
              setColor("red");
            }
          } else {
            setErrors({
              ...errors,
              [name]: "*メールアドレスが一致しません",
            });
            setColor("red");
          }
          break;
        default:
          setErrors({ ...errors, [name]: null });
          setColor("blue");
      }
      return;
    }

    setErrors({ ...errors, [name]: null });
    setColor("blue");
  };

  // 入力時の処理
  function onChange(e) {
    setFormData({ ...formData, [name]: e.target.value });
    checkInput(e.target.value);
  }

  return (
    <div className="input_box">
      <input
        id={name}
        type={type === "email" || type === "emailcheck" ? "email" : "text"}
        onChange={(e) => onChange(e)}
        value={formData[name]}
        placeholder={placeholder}
        maxLength={length}
      />
      <small className="errorMessage">{errors[name]}</small>
    </div>
  );
};
export default InputText;
